import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import HomeBannerGif from "../../../src/assets/landingPage/HomeBannerGif.gif";
import QuestionMarkMob from "../../../src/assets/landingPage/QuestionMarkMob.svg";
import QuestionMarkWeb from "../../../src/assets/landingPage/QuestionMarkWeb.png";
import BackToTop from "../../../src/assets/landingPage/TopArrow.svg";
import ICONS from "../../assets/Icons";
import designElement1 from "../../assets/landingPage/designElement1.svg";
import designElement2 from "../../assets/landingPage/designElement2.svg";
import designElement3 from "../../assets/landingPage/designElement3.svg";
import Footer from "../../components/LandingPage/Footer";
import TrustedClients from "../../components/LandingPage/TrustedClients";
import UniSecCarosel from "../../components/LandingPage/UniqueSecCarosel";
import SVGComponent from "../../components/_utils/SVGComponent";
import { toast_position } from "../../redux/features/Settings/Authorization";

const DESKTOP_CORNER_CLASS = {
  0: "lg:rounded-tl-[10px]",
  2: "lg:rounded-tr-[10px]",
  6: "lg:rounded-bl-[10px]",
  8: "lg:rounded-br-[10px]",
};

const LandingPage = () => {
  // useNavigate
  const navigate = useNavigate();

  // useState
  const [active, setActive] = useState("amcs");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [pausedTransform, setPausedTransform] = useState(null);
  const [isHover, setIsHover] = useState(false);

  // useSelector

  const intervalTime = 2000;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleMouseOver = () => {
    setIsPaused(true);
    const currentTransform = `translateX(calc(50% - ${
      currentIndex * (280 + 20) + 140
    }px))`;
    setPausedTransform(currentTransform);
  };
  const handleMouseOut = () => {
    setIsPaused(false);
    setPausedTransform(null);
  };

  const showToast = () => {
    toast.info("Feature coming soon!", toast_position);
  };

  const productSections = [
    {
      title: "Flexibility",
      description:
        "Whether you’re a small business or a large enterprise, Xpentra adapts to your specific requirements, offering scalable features that evolve as your business grows and changes.",
      image: ICONS?.FLEXIBILITY,
    },
    {
      title: "Automation",
      description:
        "Our platform automates repetitive tasks such as payments, reconciliation, and reporting, freeing up your team to focus on more strategic initiatives and reducing the risk of human error.",
      image: ICONS?.AUTOMATION_ICON,
    },
    {
      title: "Security",
      description:
        "With industry-leading encryption, multi-factor authentication, and audit trails, Xpentra guarantees that your sensitive financial information is safeguarded at every step of the transaction process.",
      image: ICONS?.SECURITY_CENTER,
    },
    {
      title: "Transparency",
      description:
        "Xpentra delivers instant access to up-to-date data, offering detailed reports and analytics that give you full visibility into your financial operations and help you make confident, data-driven decisions.",
      image: ICONS?.TRANSPARENCY,
    },
  ];

  const featureSection = [
    {
      icon: "INTEGRATION_WITH_ALL_BANKS",
      alt: "IntegrationBank",
      label: "Seamless integration with all banks",
    },
    {
      icon: "INSTANT_ACCESS_TO_ALL_ACCOUNT",
      alt: "AccessAccountBalanace",
      label: "Instant access to all account balances",
    },
    {
      icon: "PERSONALISED_BANK_ACCOUNT_STATEMENT",
      alt: "PersonalisedStatements",
      label: "Personalised bank account statements",
    },
    {
      icon: "AUTHORIZATION_MATRIX_DARK_BLUE",
      alt: "AuthMatrix",
      label: "Multi-factor authentication matrix",
    },
    {
      icon: "REAL_TIME_VENDOR_VERIFICATION",
      alt: "BeneficiaryVerification",
      label: "Real-time vendor verification & beneficiary setup",
    },
    {
      icon: "ADVANCED_SECURITY_PROTOCOLS",
      alt: "SecurityProtocols",
      label: "Advanced security protocols",
    },
    {
      icon: "MOBILE_APP_FUNCTIONALITY",
      alt: "FullyResponsive",
      label: "Full functionality accessible via mobile app",
    },
    {
      icon: "ERP_SYSTEM",
      alt: "ErpSystem",
      label: "Easy integration with ERP systems",
    },
  ];

  const solutionsSection = [
    {
      key: "amcs",
      label: "Xpentra for AMCs",
      icon: ICONS?.XPENTRA_FOR_AMCS,
      route: "/amc",
      challenges: [
        "Navigating multiple banking platforms",
        "Complex reconciliation processes",
        "Lack of real-time insights and transaction visibility",
        "Limited flexibility in transaction approvals",
        "Constraints in report generation",
        "Expensive ERP integrations",
        "Inability to switch Registrar and Transfer Agent (RTA)",
      ],
      solutions: [
        "Centralised banking dashboard",
        "End-to-end reconciliation",
        "Real-time analytics",
        "Customisable authorisation matrix",
        "Advanced MIS reporting",
        "Cost-efficient ERP integration with Xpentra",
        "Flexible adaptation to any RTA",
      ],
    },
    {
      key: "corporates",
      label: "Xpentra for Corporates",
      icon: ICONS?.XPENTRA_FOR_CORPORATES,
      route: "/corporates",
      challenges: [
        "Lack of automation",
        "Inefficient transaction approval processes",
        "Limited treasury investment visibility",
        "Expensive ERP integrations",
        "Manual reconciliation and transaction tracking",
        "Inadequate security measures",
        "Delays in beneficiary and vendor transactions",
        "Limited visibility on account collections",
      ],
      solutions: [
        "Automated transaction workflows",
        "Streamlined payables management",
        "Comprehensive treasury visibility",
        "Cost-efficient ERP integrations",
        "End-to-end reconciliation processes",
        "Complete transaction trails with real-time visibility",
        "Advanced security mechanisms",
        "Real-time vendor and beneficiary registration",
        "Custom notifications and real-time collections tracking",
      ],
    },
  ];

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "34px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  // useEffect
  useEffect(() => {
    const scrollListener = () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    };
    window.addEventListener("scroll", scrollListener);
    return () => {
      window.removeEventListener("scroll", scrollListener);
    };
  }, [scrollPercent]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setCurrentIndex(
          (prevIndex) => (prevIndex + 1) % productSections.length,
        );
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [isPaused, productSections.length]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };

    const handleScroll = () => {
      if (window.scrollY > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}
        <div style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            WebkitOverflowScrolling: "touch",
          }}
          className="bg-[#031f4f] lg:bg-transparent overflow-x-hidden"
        >
          <div className="w-full p-[30px] lg:p-0 flex relative mt-[60px] bg-[#1f3969]">
            <div
              className="w-full lg:p-0 flex sm:flex-row md:gap-16 flex-col-reverse
              lg:flex-row lg:justify-between
              gap-2.5 lg:h-[492px] lg:max-w-[1440px] lg:w-screen lg:mx-auto lg:relative"
            >
              <div
                className="flex flex-col gap-2.5 lg:gap-0 xs:min-w-[260px]
                 my-auto lg:my-0 lg:w-[50%]
                lg:pl-[125px] lg:justify-center"
              >
                <p
                  className="text-text-primary text-lg lg:leading-[1.2] font-semibold
                  lg:text-font-xl"
                >
                  Your all-in-one platform for streamlined financial management
                </p>

                <p
                  className="text-text-primary text-sm font-normal lg:text-font-sm
                  lg:leading-[unset] lg:mt-2.5"
                >
                  Xpentra is a sophisticated platform designed to simplify
                  complex financial processes, using robust tools to offer
                  advanced capabilities in managing accounts and transactions
                  efficiently. Xpentra acts as a powerful CXO enabler, with its
                  intuitive dashboards and analytics delivering expert insights
                  into cash and liquidity management, financial projections,
                  and forecasting.
                </p>

                <div
                  onClick={() => navigate("/book_demo")}
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => setIsHover(false)}
                  className="cursor-pointer rounded-[5px] w-[112px] lg:w-[125px]
                    h-9 lg:h-auto p-2.5 lg:py-[10px] flex justify-between lg:justify-center
                    text-xs font-semibold text-[#031F4F] bg-text-primary hover:bg-primary-bg
                    lg:text-center lg:gap-2.5 lg:items-center lg:mt-5
                    lg:hover:bg-opacity-20 lg:hover:text-text-primary"
                >
                  <span>Book a demo</span>
                  <div className="h-3.5 w-3.5 my-auto">
                    <SVGComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      height={"12px"}
                      width={"12px"}
                      color={
                        isHover
                          ? "var(--text-primary)"
                          : "var(--primary-bg)"
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="mx-auto lg:hidden w-full">
                <img
                  className="max-w-[260px]"
                  src={HomeBannerGif}
                  alt="HeroSectionBannerMobile"
                />
              </div>

              <div className="hidden lg:block lg:w-[640px] lg:h-[492px] lg:pl-[125px] lg:py-[15px]">
                <div className="h-[432px] w-[391px]">
                  <img
                    src={HomeBannerGif}
                    alt="HomeBannerGif"
                  />
                </div>
              </div>

              {/* Desktop Design Element 3 - Top */}
              <div
                className="
                  hidden

                  lg:block
                  lg:absolute
                  lg:h-[62px]
                  lg:w-[65px]
                  lg:ml-[150px]
                  lg:mt-[30px]
                "
              >
                <img
                  src={designElement3}
                  alt=""
                />
              </div>

              {/* Desktop Design Element 3 - Bottom */}
              <div
                className="
                  hidden

                  lg:block
                  lg:absolute
                  lg:h-[62px]
                  lg:w-[65px]
                  lg:ml-[50px]
                  lg:mt-[395px]
                "
              >
                <img
                  src={designElement3}
                  alt=""
                />
              </div>
            </div>

            {/* Left Design Element */}
            <div
              className="
                hidden

                lg:block
                lg:absolute
                lg:h-[100px]
                lg:w-[218px]
                lg:left-[-60px]
                lg:top-[25%]
              "
            >
              <img
                src={designElement1}
                alt=""
              />
            </div>

            {/* Right Top Design Element */}
            <div
              className="
                hidden

                lg:block
                lg:absolute
                lg:h-[62px]
                lg:w-[65px]
                lg:right-[50px]
                lg:mt-[75px]
              "
            >
              <img
                src={designElement3}
                alt=""
              />
            </div>

            {/* Right Middle Design Element */}
            <div
              className="
                hidden

                lg:block
                lg:absolute
                lg:h-[62px]
                lg:w-[65px]
                lg:right-0
                lg:mt-[225px]
                lg:rotate-90
              "
            >
              <img
                src={designElement2}
                alt=""
              />
            </div>

            {/* Right Bottom Design Element */}
            <div
              className="
                hidden

                lg:block
                lg:absolute
                lg:h-[62px]
                lg:w-[65px]
                lg:right-[25px]
                lg:mt-[375px]
              "
            >
              <img
                src={designElement2}
                alt=""
              />
            </div>
          </div>

          <div className="p-[30px] bg-[#031F4F] lg:px-[171px] lg:py-[30px] flex
          flex-col gap-4 md:gap-0 lg:gap-2.5">
            <div className="max-w-[1024px] lg:mx-auto flex flex-wrap justify-center
              gap-4 lg:gap-2.5 lg:grid lg:grid-cols-3">
              <div className="w-full lg:w-[334px] lg:h-[147px] text-base lg:text-font-xl
               text-text-primary font-semibold lg:bg-[#112C5D]
               lg:px-5 lg:py-[36px] lg:flex lg:items-center justify-center
               lg:justify-start lg:rounded-tl-[10px]">
                <span className="text-pending">Key features</span>&nbsp;of Xpentra
              </div>
      
              {featureSection.map((f, i) => {
                const gridIndex = i + 1;
                const corner = DESKTOP_CORNER_CLASS[gridIndex] || "";
                return (
                  <div
                    key={f.icon}
                    className={`rounded-[10px] lg:rounded-none ${corner} bg-[#314D7E]
                    lg:bg-[#244277] flex flex-col gap-2.5 lg:gap-0 h-[138px] lg:h-[147px]
                     w-[140px] lg:w-[334px] p-5 lg:px-5 lg:py-[36px]
                    `}
                  >
                    <div className="h-10 w-10 lg:h-[60px] lg:w-[60px] rounded-[50%]
                     bg-[#102c5d] lg:bg-transparent">
                      <img
                        className="lg:h-[60px] lg:w-[60px]"
                        src={ICONS?.[f.icon]}
                        alt={f.alt}
                      />
                    </div>
                    <div className="text-xs text-text-primary font-normal lg:font-semibold h-12 lg:h-auto lg:mt-2.5">
                      {f.label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="py-5 px-[30px] sm:px-[30px] lg:m-0 lg:p-0 lg:text-font-xl lg:pt-5
           lg:pb-[30px] lg:text-text-primary 
            bg-[linear-gradient(90deg,#031f4f_0%,#224074_50%,#031f4f_100%)]
            lg:bg-[linear-gradient(270deg,#031F4F_0%,#1C3A6D_27%,#224074_50%,#031F4F_100%,#234176_100%)]"
          >
            <p className="text-text-primary text-base font-semibold mb-5 text-left sm:text-center
            lg:text-font-xl">
              Product <span className="text-pending">advantages</span>
            </p>
            <div className="hidden lg:flex flex-col gap-4">
              <div className="flex max-w-[1024px] mx-auto gap-4">
                {productSections.slice(0, 2).map((section, index) => (
                  <div key={index} className="flex h-[200px] w-[502px] flex-col gap-4 rounded-[20px] border border-pending px-[30px] py-[18px]">
                    <div className="h-[60px] w-[60px] rounded-[50%]">
                      <img className="h-[60px] w-[60px]" src={section.image} alt={section.title} />
                    </div>
                    <div className="flex flex-col gap-[5px]">
                      <p className="text-base font-semibold text-text-primary">{section.title}</p>
                      <p className="text-xs text-text-primary">{section.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex max-w-[1024px] mx-auto gap-4">
                {productSections.slice(2, 4).map((section, index) => (
                  <div key={index} className="flex h-[200px] w-[502px] flex-col gap-4 rounded-[20px] border border-pending px-[30px] py-[18px]">
                    <div className="h-[60px] w-[60px] rounded-[50%]">
                      <img className="h-[60px] w-[60px]" src={section.image} alt={section.title} />
                    </div>
                    <div className="flex flex-col gap-[5px]">
                      <p className="text-base font-semibold text-text-primary">{section.title}</p>
                      <p className="text-xs text-text-primary">{section.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:hidden">
              <div className="relative h-[218px] w-full overflow-hidden">
                <div
                  className="flex gap-5"
                  style={{
                    transform: isPaused ? pausedTransform : `translateX(calc(50% - ${currentIndex * (280 + 20) + 140}px))`,
                    transition: isPaused ? "none" : "transform 700ms ease-in-out",
                  }}
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                >
                  {productSections.map((section, index) => (
                    <div key={index}
                      className="max-w-[280px] flex-shrink-0 h-[218px] p-5 rounded-[10px]
                       border-[1px] border-pending">
                      <div className="flex flex-col gap-2.5">
                        <div className="h-10 w-10 rounded-[50%]">
                          <img src={section.image} alt={section.title}/>
                        </div>
                        <div className="text-base font-semibold text-text-primary">{section.title}</div>
                        <div className="text-xs font-normal text-text-primary">{section.description}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mx-auto mt-2.5 flex max-w-[230px] justify-center gap-2.5">
                {productSections.map((_, index) => (
                  <div key={index} className={`h-[4px] rounded-[18px] bg-text-primary
                    transition-all duration-500 ease-in-out
                    ${index === currentIndex ? "w-[80px] opacity-100" : "w-[40px] opacity-50"}`}></div>
                ))}
              </div>
            </div>
          </div>

          <UniSecCarosel />

          <div className="bg-[#031F4F] pb-[30px] py-5 lg:py-0
            bg-[linear-gradient(90deg,#031f4f_0%,#224074_50%,#031f4f_100%)] 
            lg:bg-[linear-gradient(270deg,#031F4F_0%,#1C3A6D_27%,#224074_50%,#031F4F_100%,#234176_100%)]">
            <div className="lg:max-w-[1024px] lg:mx-auto lg:py-5 lg:flex lg:flex-col lg:gap-2.5">
              <div>
                <p className="lg:text-font-xl text-text-primary text-center font-semibold">
                  <span className="text-pending">Tailored solutions</span> for
                  business needs
                </p>
                <p className="text-xs text-text-primary text-center px-5 mt-5 lg:mt-0 lg:px-0
                 font-semibold lg:font-normal">
                  Our custom solutions are designed to address the unique
                  challenges faced by AMC's and corporates.
                </p>
              </div>
              <div className="lg:hidden rounded-[170px] w-full h-12 bg-[#031F4F] p-2 mx-5 my-4 flex text-text-primary text-xs font-semibold text-center w-[calc(100%-40px)]">
                {solutionsSection.map((item) => (
                  <div
                    key={item.key}
                    className={`w-1/2 flex items-center justify-center cursor-pointer ${
                      active === item.key
                        ? "bg-[rgba(49,77,126)] rounded-[500px]"
                        : ""
                    }`}
                    onClick={() => setActive(item.key)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
              <div className="flex flex-col lg:mt-5 mx-5 lg:mx-0 lg:border-[1px] lg:border-pending lg:rounded-[20px]">
                {solutionsSection.map((item, idx) => (
                  <div
                    key={item.key}
                    className={`${active === item.key ? "flex" : "hidden"} lg:flex
                      flex-col lg:flex-row lg:gap-0
                      ${idx === 0 ? "lg:border-b-[1px] lg:border-b-pending" : ""}
                    `}
                  >
                    <div className="hidden lg:flex w-full lg:w-[342px] flex-col gap-[5px] p-5 my-[20px] border-r-[1px] border-r-pending">
                      <div className="h-full">
                        <div className="w-[150px] h-[150px] rounded-[20px] mx-auto">
                          <img className="w-width-full" src={item.icon} alt={item.key} />
                        </div>
                        <p className="text-xs w-[150px] text-text-primary text-center mt-2.5 mx-auto">
                          {item.label}
                        </p>
                        <div
                          onClick={() => navigate(item.route)}
                          onMouseEnter={() => setIsHover(true)}
                          onMouseLeave={() => setIsHover(false)}
                          className="cursor-pointer rounded-[5px] w-[150px] mt-2.5 mx-auto text-center text-xs font-semibold py-[10px] flex gap-2.5 items-center justify-center text-[#031F4F] bg-text-primary hover:text-text-primary hover:bg-opacity-20"
                        >
                          <span>Learn More</span>
                          <SVGComponent
                            url={ICONS?.ARROW_RIGHT_WHITE}
                            height={"12px"}
                            width={"12px"}
                            color={isHover ? "var(--text-primary)" : "var(--primary-bg)"}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-[683px]">
                      <div
                        className="h-auto lg:h-[398px] py-5 px-[10px] flex gap-2.5 lg:gap-0 lg:justify-around
                          rounded-[10px] lg:rounded-none border-[1px] lg:border-0 border-pending"
                      >
                        <div className="text-text-primary w-full lg:w-[310px] flex flex-col gap-2.5 border-r-[1px] border-r-pending">
                          <p className="text-xs lg:text-base font-semibold">Challenges :</p>
                          <ul
                            className="text-font-xxs lg:text-xs pl-[15px] lg:pl-[5px] mt-5 lg:mt-0
                            list-disc leading-[2] lg:leading-[3]"
                          >
                            {item.challenges.map((c) => (
                              <li key={c}>{c}</li>
                            ))}
                          </ul>
                        </div>
                        <div className="text-text-primary w-full lg:w-[310px] flex flex-col gap-2.5">
                          <p className="text-xs lg:text-base font-semibold">
                            Solutions we provide :
                          </p>
                          <ul
                            className="text-font-xxs lg:text-xs pl-[15px] lg:pl-[5px] mt-5 lg:mt-0
                            list-disc leading-[2] lg:leading-[3]"
                          >
                            {item.solutions.map((s) => (
                              <li key={s}>{s}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div
                      className="lg:hidden mt-5 w-[112px] h-[36px] rounded-[5px] p-2.5 text-[#031F4F] bg-text-primary flex justify-between cursor-pointer"
                      onClick={() => navigate(item.route)}
                      onMouseEnter={() => setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                    >
                      <div className="text-xs h-4 font-semibold">
                        <span>Learn More</span>
                      </div>
                      <div className="h-[14px] w-[14px] my-auto">
                        <SVGComponent
                          url={ICONS?.ARROW_RIGHT_WHITE}
                          height={"12px"}
                          width={"12px"}
                          color={isHover ? "var(--text-primary)" : "var(--primary-bg)"}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-[#031F4F] pb-[30px] lg:pb-0 lg:pt-[35px]">
            <div className="bg-[linear-gradient(87.27deg,#031f4f_3.97%,#224074_56.2%)]
              lg:bg-[linear-gradient(270deg,#031F4F_0%,#1C3A6D_27%,#224074_50%,#031F4F_100%,#234176_100%)]
               w-full py-5 px-5 lg:p-0 mt-[30px] lg:my-5 flex flex-col relative items-center gap-5 lg:gap-10">
              <TrustedClients />
            </div>
          </div>

          <div className="bg-[linear-gradient(87.27deg,#031f4f_3.97%,#224074_56.2%)]
           lg:bg-[#031F4F] h-[186px] lg:h-[217px] w-full py-5 lg:py-0 flex flex-col relative">
            <div className="lg:bg-[linear-gradient(90deg,rgb(34,64,116)_0%,rgb(3,31,79)_100%)]
             lg:h-[217px]">
              <div className="px-[30px] lg:px-0 lg:max-w-[1024px] lg:mx-auto lg:py-5 
              flex gap-4 lg:justify-between">
                <div>
                  <div className="text-text-primary flex flex-col gap-4 lg:gap-2.5">
                    <p className="text-base lg:text-font-xl font-semibold lg:leading-[1.2]">
                      Get your questions
                      <br className="hidden lg:block" />
                      <span className="text-pending"> answered</span>
                    </p>

                    <p className="text-xs font-normal">
                      For frequently asked questions, Xpentra has a help centre page
                      and user manual.
                      <br className="hidden lg:block" /> Also, clients can raise a
                      support ticket via&nbsp;
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=support@q2pay.in"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                      >
                        support@q2pay.in
                      </a>
                    </p>
                    <div
                      onClick={() => {
                        showToast();
                      }}
                      onMouseEnter={() => setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                      className="cursor-pointer rounded-[5px] w-[96px] lg:w-[109px] h-[36px]
                        lg:h-auto text-center text-xs font-semibold p-2.5 lg:py-[10px] lg:px-0 flex gap-2.5
                       items-center justify-between lg:justify-center text-[#031F4F]
                        bg-text-primary hover:text-text-primary hover:bg-opacity-20 lg:mt-[10px]"
                    >
                      <div className="h-4">For FAQs</div>

                      <div className="h-[14px] w-[14px] lg:h-auto lg:w-auto my-auto">
                        <SVGComponent
                          url={ICONS?.ARROW_RIGHT_WHITE}
                          height={"12px"}
                          width={"12px"}
                          color={
                            isHover
                              ? "var(--text-primary)"
                              : "var(--primary-bg)"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-0 right-0 lg:static">
                  <img
                    src={QuestionMarkMob}
                    alt="QuestionMarkMob"
                    className="lg:hidden"
                  />

                  <img
                    src={QuestionMarkWeb}
                    alt="questionMark"
                    className="hidden lg:block"
                  />
                </div>
              </div>
            </div>
          </div>

          <Footer />

        </div>
      </div>
    </div>
  );
};

export default LandingPage;
